import api from '../../utils/services/api';

import {
  loginActionError,
  loginActionLoading,
  loginActionSuccess,
  authenticateActionError,
  authenticateActionLoading,
  authenticateActionSuccess,
} from '../ducks/login';
import { showAlert } from '../ducks/sweetAlert';

export const loginFetchAction = (params, navigate) => {
  return async (dispatch) => {
    dispatch(loginActionLoading());
    try {
      const response = await api.post(`coban/novaAutenticacao/validar`, params);
      dispatch(loginActionSuccess(response.data));
      localStorage.setItem('is_authenticate', response?.data?.jwt);
      api.defaults.headers = {
        jwt: `${response?.data?.jwt}`,
      };
      localStorage.setItem('cpfcnpj', params.CPFCNPJ);
      navigate('/dashboard');
    } catch (error) {
      const errorMessage =
        error?.response?.data?.mensagem || 'Ocorreu algo inesperado';
      dispatch(loginActionError(errorMessage));
      dispatch(
        showAlert({
          title: 'Ops...',
          text: errorMessage,
          icon: 'error',
        }),
      );
    }
  };
};

export const authenticateFetchAction = (params, callback) => {
  return async (dispatch) => {
    dispatch(authenticateActionLoading());
    try {
      const response = await api.post(`coban/autenticacao/enviar`, params);
      dispatch(authenticateActionSuccess(response.data));
      callback();
    } catch (error) {
      const errorMessage = error?.response?.data?.mensagem;
      dispatch(authenticateActionError(error?.response?.data));
      dispatch(
        showAlert({
          title: 'Ops...',
          text: errorMessage,
          icon: 'error',
        }),
      );
    }
  };
};
